import { Dialog, DialogContent, Grid, IconButton, MenuItem } from "@mui/material";
import FilterSelect from "../../component/select/filterSelect";
import Dashboard1 from "./dashboard1/dashboard1";
import Dashboard2 from "./dashboard2/dashboard2";
import Dashboard3 from "./dashboard3/dashboard3";
import Dashboard4 from "./dashboard4/dashboard4";
import { LayoutTitle, LayoutView, TitleText } from "../../component/layout/layoutMainStyle";
import { useEffect, useState } from "react";
import InputDatePicker from "../../component/input/inputDatePicker";
import moment from 'moment';
import FilterListIcon from '@mui/icons-material/FilterList';
import AutocompleteSelect from "../../component/select/autoCompleteSelect";
import FolderApi from "../../api/folder/folder.api";
import DepartmentApi from "../../api/departments/departments.api";
import ButtonCustom from "../../component/button/buttonCustom";
import DashboardApi from "../../api/dashboard/dashboard.api";
import saveAs from "file-saver";
import { getYearOptions } from "../../utils/app.utils";


export default function Dashboard() {
    
    const [sdate, setSdate] = useState<string>('');
    const [edate, setEdate] = useState<string>('');
    const [keywordLevel1, setKeywordLevel1] = useState<string>('');
    const [keywordLevel2, setKeywordLevel2] = useState<string>('');
    const [keywordLevel3, setKeywordLevel3] = useState<string>('');
    const [keywordLevel4, setKeywordLevel4] = useState<string>('');
    const [idDepartment, setIdDepartment] = useState<number>();
    const [departments, setDepartments] = useState<any>([]);
    const [folderName, setFolderName] = useState<any>([]);
    const [idFiscalYear, setIdFiscalYear] = useState<string>('');
    const [openFilter, setOpenFilter] = useState<boolean>(false);
    
    const yearOptions = getYearOptions();

    const loadFolderName = async () => {
        const res = await FolderApi.getFolderName()
        const data = await res.data;
        if (data?.success) {
            setFolderName(data.result)
        }
    }

    const getDepartments = async () => {
        const res = await DepartmentApi.getDepartments({})
        const data = res.data
        if (data.success) {
            setDepartments(data.result.items)
        }
    }

    useEffect(() => {
        loadFolderName()
        getDepartments()
    }, [])
    const download = async () => {
        let condition: any = {};
        if (idDepartment) condition = { ...condition, idDepartment: idDepartment };
        if (idFiscalYear) condition = { ...condition, idFiscalYear: idFiscalYear === 'all' ? '' : idFiscalYear };
        if (keywordLevel1) condition = { ...condition, keywordLevel1: keywordLevel1 };
        if (keywordLevel2) condition = { ...condition, keywordLevel2: keywordLevel2 };
        if (keywordLevel3) condition = { ...condition, keywordLevel3: keywordLevel3 };
        if (keywordLevel4) condition = { ...condition, keywordLevel4: keywordLevel4 };
        if (sdate) condition = { ...condition, startDate: sdate };
        if (edate) condition = { ...condition, endDate: edate };
        DashboardApi.getDashboardSummaryDownload(condition).then((res) => {
            const data = res.data;
            const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            saveAs(blob, 'รายงาน');
        }
        );
    }
    return (
        <LayoutView>
            <LayoutTitle>
                <TitleText>สถิติข้อมูล</TitleText>
                <IconButton onClick={() => setOpenFilter(true)} aria-label="Example" sx={{ display: { lg: 'none', xs: 'block' } }}>
                    <FilterListIcon />
                </IconButton>
            </LayoutTitle>
            <Grid container columns={14} sx={{ marginBottom: '12px', display: { lg: 'flex', xs: 'none' } }}>
                <Grid md={2} xs={12} sx={{ marginRight: '10px' }}>
                    <InputDatePicker
                        dateFormat="DD/MM/YYYY"
                        required={false}
                        key={""}
                        disabled={false}
                        label=""
                        value={sdate}
                        onClear={() => setSdate('')}
                        onChange={(e: any) => setSdate(moment(e).format("YYYY-MM-DD"))
                        }
                        allowClear
                        heading={'ตั้งแต่วันที่'} />
                </Grid>
                <Grid md={2} xs={12} sx={{ marginRight: '10px' }}>

                    <InputDatePicker
                        dateFormat="DD/MM/YYYY"
                        required={false}
                        key={""}
                        disabled={false}
                        label=""
                        value={edate}
                        onClear={() => setEdate('')}
                        onChange={(e: any) => setEdate(moment(e).format("YYYY-MM-DD"))
                        }
                        allowClear
                        heading={'ถึงวันที่'} />
                </Grid>
                <Grid md={3} xs={12} sx={{ marginRight: '10px' }}>
                    <AutocompleteSelect
                        options={folderName?.level1}
                        // disabled={location.state.params.isView}
                        getOptionLabel={(option: any) => option}
                        labelId="addmin-type"
                        inputValue={keywordLevel1}
                        heading={'ตู้เอกสาร/หน่วยงาน'}
                        placeholder='ทั้งหมด'
                        onInputChange={(event, newValue) => {
                            setKeywordLevel1(newValue)
                        }}
                        // required
                        helperText={''}
                    />
                </Grid>
                <Grid md={3} xs={12} sx={{ marginRight: '10px' }}>
                    <AutocompleteSelect
                        options={folderName?.level2}
                        // disabled={location.state.params.isView}
                        getOptionLabel={(option: any) => option}
                        labelId="addmin-type"
                        inputValue={keywordLevel2}
                        heading={'ชั้นเอกสาร'}
                        placeholder='ทั้งหมด'
                        onInputChange={(event, newValue) => {
                            setKeywordLevel2(newValue)
                        }}
                        // required
                        helperText={''}
                    />
                </Grid>
                <Grid md={3} xs={12} sx={{ marginRight: '10px' }}>
                    <AutocompleteSelect
                        options={folderName?.level3}
                        // disabled={location.state.params.isView}
                        getOptionLabel={(option: any) => option}
                        labelId="addmin-type"
                        inputValue={keywordLevel3}
                        heading={'แฟ้มเอกสาร'}
                        placeholder='ทั้งหมด'
                        onInputChange={(event, newValue) => {
                            setKeywordLevel3(newValue)
                        }}
                        // required
                        helperText={''}
                    />
                </Grid>
                <Grid md={3} xs={12} sx={{ marginRight: '10px' }}>
                    <AutocompleteSelect
                        options={folderName?.level4}
                        // disabled={location.state.params.isView}
                        getOptionLabel={(option: any) => option}
                        labelId="addmin-type"
                        inputValue={keywordLevel4}
                        heading={'ประเภทเอกสาร'}
                        placeholder='ทั้งหมด'
                        onInputChange={(event, newValue) => {
                            setKeywordLevel4(newValue)
                        }}
                        // required
                        helperText={''}
                    />
                </Grid>
                <Grid md={2} xs={12} sx={{ marginRight: '10px' }}>
                    <FilterSelect heading='หน่วยงาน' labelId='' selectId='' options={departments.map((x: any, i: number) => {
                        return (
                            <MenuItem key={i}
                                value={x.idDepartment}
                            >
                                {x.departmentName}
                            </MenuItem>
                        )
                    })} value={idDepartment} onchange={(e: any) => { setIdDepartment(e.target.value) }} />
                </Grid>
                <Grid md={2} xs={12} sx={{ marginRight: '10px' }}>
                    <FilterSelect heading='ปีงบประมาณ' labelId='' selectId='' options={[{ value: 'all', name: 'ทั้งหมด' }, ...yearOptions].map((x, i) => {
                        return (
                            <MenuItem key={i}
                                value={x.value}
                            >
                                {x.name}
                            </MenuItem>
                        )
                    })} value={idFiscalYear} onchange={(e: any) => { setIdFiscalYear(e.target.value) }} />
                </Grid>
                <Grid md={6} xs={12} sx={{ display: 'flex', alignItems: 'end', justifyContent: "end" }}>
                    <ButtonCustom textButton={'ดาวน์โหลด'} onClick={() => download()} />
                </Grid>
            </Grid>
            <Grid container spacing={2}>
                <Grid item md={4} xs={12}>
                    <Dashboard1 idDepartment={idDepartment} idFiscalYear={idFiscalYear} keywordLevel1={keywordLevel1} keywordLevel2={keywordLevel2} keywordLevel3={keywordLevel3} keywordLevel4={keywordLevel4} endDate={edate} startDate={sdate} />
                </Grid>
                <Grid item md={8} xs={12}>
                    <Dashboard2 idDepartment={idDepartment} idFiscalYear={idFiscalYear} keywordLevel1={keywordLevel1} keywordLevel2={keywordLevel2} keywordLevel3={keywordLevel3} keywordLevel4={keywordLevel4} endDate={edate} startDate={sdate} />
                </Grid>
                <Grid item md={6} xs={12}>
                    <Dashboard3 idDepartment={idDepartment} idFiscalYear={idFiscalYear} keywordLevel1={keywordLevel1} keywordLevel2={keywordLevel2} keywordLevel3={keywordLevel3} keywordLevel4={keywordLevel4} endDate={edate} startDate={sdate} />
                </Grid>
                <Grid item md={6} xs={12}>
                    <Dashboard4 idDepartment={idDepartment} idFiscalYear={idFiscalYear} keywordLevel1={keywordLevel1} keywordLevel2={keywordLevel2} keywordLevel3={keywordLevel3} keywordLevel4={keywordLevel4} endDate={edate} startDate={sdate} />
                </Grid>
            </Grid>
            <Dialog
                open={openFilter}
                onClose={() => setOpenFilter(false)}>
                <DialogContent>
                    <Grid container columns={12} sx={{ marginBottom: '12px', }}>
                        <Grid xs={12} sx={{ marginRight: '10px' }}>
                            <InputDatePicker
                                dateFormat="DD/MM/YYYY"
                                required={false}
                                key={""}
                                disabled={false}
                                label=""
                                value={sdate}
                                onClear={() => setSdate('')}
                                onChange={(e: any) => setSdate(moment(e).format("YYYY-MM-DD"))
                                }
                                allowClear
                                heading={'ตั้งแต่วันที่'} />
                        </Grid>
                        <Grid xs={12} sx={{ marginRight: '10px' }}>

                            <InputDatePicker
                                dateFormat="DD/MM/YYYY"
                                required={false}
                                key={""}
                                disabled={false}
                                label=""
                                value={edate}
                                onClear={() => setEdate('')}
                                onChange={(e: any) => setEdate(moment(e).format("YYYY-MM-DD"))
                                }
                                allowClear
                                heading={'ถึงวันที่'} />
                        </Grid>
                        <Grid xs={12} sx={{ marginRight: '10px' }}>
                            <AutocompleteSelect
                                options={folderName?.level1}
                                // disabled={location.state.params.isView}
                                getOptionLabel={(option: any) => option}
                                labelId="addmin-type"
                                inputValue={keywordLevel1}
                                heading={'ตู้เอกสาร/หน่วยงาน'}
                                placeholder='ทั้งหมด'
                                onInputChange={(event, newValue) => {
                                    setKeywordLevel1(newValue)
                                }}
                                // required
                                helperText={''}
                            />
                        </Grid>
                        <Grid xs={12} sx={{ marginRight: '10px' }}>
                            <AutocompleteSelect
                                options={folderName?.level2}
                                // disabled={location.state.params.isView}
                                getOptionLabel={(option: any) => option}
                                labelId="addmin-type"
                                inputValue={keywordLevel2}
                                heading={'ชั้นเอกสาร'}
                                placeholder='ทั้งหมด'
                                onInputChange={(event, newValue) => {
                                    setKeywordLevel2(newValue)
                                }}
                                // required
                                helperText={''}
                            />
                        </Grid>
                        <Grid xs={12} sx={{ marginRight: '10px' }}>
                            <AutocompleteSelect
                                options={folderName?.level3}
                                // disabled={location.state.params.isView}
                                getOptionLabel={(option: any) => option}
                                labelId="addmin-type"
                                inputValue={keywordLevel3}
                                heading={'แฟ้มเอกสาร'}
                                placeholder='ทั้งหมด'
                                onInputChange={(event, newValue) => {
                                    setKeywordLevel3(newValue)
                                }}
                                // required
                                helperText={''}
                            />
                        </Grid>
                        <Grid xs={12} sx={{ marginRight: '10px' }}>
                            <AutocompleteSelect
                                options={folderName?.level4}
                                // disabled={location.state.params.isView}
                                getOptionLabel={(option: any) => option}
                                labelId="addmin-type"
                                inputValue={keywordLevel4}
                                heading={'ประเภทเอกสาร'}
                                placeholder='ทั้งหมด'
                                onInputChange={(event, newValue) => {
                                    setKeywordLevel4(newValue)
                                }}
                                // required
                                helperText={''}
                            />
                        </Grid>
                        <Grid xs={12} sx={{ marginRight: '10px' }}>
                            <FilterSelect heading='หน่วยงาน' labelId='' selectId='' options={departments.map((x: any, i: number) => {
                                return (
                                    <MenuItem key={i}
                                        value={x.idDepartment}
                                    >
                                        {x.departmentName}
                                    </MenuItem>
                                )
                            })} value={idDepartment} onchange={(e: any) => { setIdDepartment(e.target.value) }} />
                        </Grid>
                        <Grid xs={12} sx={{ marginRight: '10px' }}>
                            <FilterSelect heading='ปีงบประมาณ' labelId='' selectId='' options={[{ value: 'all', name: 'ทั้งหมด' }, ...yearOptions].map((x, i) => {
                                return (
                                    <MenuItem key={i}
                                        value={x.value}
                                    >
                                        {x.name}
                                    </MenuItem>
                                )
                            })} value={idFiscalYear} onchange={(e: any) => { setIdFiscalYear(e.target.value) }} />
                        </Grid>
                        <Grid xs={12} sx={{
                            display: 'flex', alignItems: 'end', justifyContent: "end",
                            marginTop: '20px'
                        }}>
                            <ButtonCustom textButton={'ดาวน์โหลด'} onClick={() => download()} />
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
        </LayoutView>
    )
}
